//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

const URL = import.meta.env.VITE_DRIVER_MILEAGE_API || `${window.location.origin}/driver-mileage`;

export interface IDriverMileageClient {
	/**
	 * Gets driver mileage information by policy token.
	 * @param policyToken (optional) The encrypted policy token that uniquely identifies the insurance policy.
	 * @return OK
	 */
	getDriverMileage(policyToken: string | undefined): Promise<DriverMileageDto>;
}

export class DriverMileageClient implements IDriverMileageClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Gets driver mileage information by policy token.
	 * @param policyToken (optional) The encrypted policy token that uniquely identifies the insurance policy.
	 * @return OK
	 */
	getDriverMileage(policyToken: string | undefined, cancelToken?: CancelToken): Promise<DriverMileageDto> {
		let url_ = this.baseUrl + '/api/v1/DriverMileage/GetDriverMileage?';
		if (policyToken === null) throw new Error("The parameter 'policyToken' cannot be null.");
		else if (policyToken !== undefined) url_ += 'policyToken=' + encodeURIComponent('' + policyToken) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetDriverMileage(_response);
			});
	}

	protected processGetDriverMileage(response: AxiosResponse): Promise<DriverMileageDto> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<DriverMileageDto>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<DriverMileageDto>(null as any);
	}
}

/** Data transfer object for driver mileage information */
export interface DriverMileageDto {
	/** Policy number of the driver */
	policyNumber?: string | undefined;
	/** Actual miles driven */
	actualMiles?: number;
	/** Price per mile */
	pricePerMile?: number;
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export class SwaggerException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isSwaggerException = true;

	static isSwaggerException(obj: any): obj is SwaggerException {
		return obj.isSwaggerException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
